<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">Supplier #{{supplier.code}} - {{supplier.name}}</h4>
                    <p class="text-subtitle-1">Displaying Supplier Information</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3" v-if="hasPermission(perm.supplier.update)">
                    <v-btn block @click="handleEdit" depressed>
                        <v-icon left>mdi-pencil</v-icon>
                        edit
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3">
                    <v-btn block depressed color="error--text" @click="handleRemove">
                        <v-icon left>mdi-delete</v-icon>
                        delete
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <Supplier :value="supplier" v-if="supplier"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-btn color="primary" block class="mb-4" @click="handleNewPurchaseOrder">
                        <v-icon left>mdi-plus</v-icon>
                        new purchase order
                    </v-btn>
                    <v-btn depressed block @click="handleNewAccount" v-if="hasPermission(perm.supplier_account.create)" class="mb-4">
                        <v-icon left>mdi-cash</v-icon>
                        new account
                    </v-btn>
                    <v-btn depressed block @click="handleNewContact()" v-if="hasPermission(perm.supplier_contact.create)">
                        <v-icon left>mdi-phone</v-icon>
                        new contact
                    </v-btn>
                </v-col>
                <v-col cols="12" md="9">
                    <v-tabs v-model="tab" color="primary">
                        <v-tab>Accounts</v-tab>
                        <v-tab>Contacts</v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tab">
                        <v-tab-item>
                            <SupplierAccountList :value="supplier ? supplier.accounts : []" :supplier-id="supplier ? supplier.id : null"/>
                        </v-tab-item>
                        <v-tab-item>
                            <SupplierContactlist :value="supplier ? supplier.contacts : []"/>
                        </v-tab-item>
                    </v-tabs-items>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
                <v-col cols="12" md="9">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
            
        </div>
        <PAlert v-bind="alert" v-model="alertShown"/>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions';
import { mapActions, mapGetters } from 'vuex';
import Supplier from './../../components/purchase/Supplier';
import PAlert from './../../components/common/PAlert';
import SupplierAccountList from '@/components/purchase/SupplierAccountList';
import SupplierContactlist from './../../components/purchase/SupplierContactList.vue'
export default {
    name: "SupplerDisplayView",
    components: {
        Supplier,
        PAlert,
        SupplierAccountList,
        SupplierContactlist
    },
    data() {
        return {
            id: null,
            loading: false,
            supplier: null,
            alertShown: false,
            alert: {
                title: "Alert",
                content: "Are you sure?",
                callback: null
            },
            errors: [],
            perm: permissions,
            tab: 0
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            find: "purchase/supplier/find",
            remove: "purchase/supplier/remove",
            snackbar: "ui/snackbar/show"
        }),
        getSupplier() {
            this.loading = true;
            this.errors = [];
            this.find(this.id).then(response => {
                this.supplier = response.data;
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.errors.push(message);
                this.supplier = null;
                this.snackbar({color: "error", text: message})
            }).finally(() => {
                this.loading = false;
            })
        },
        handleNew() {
            this.$router.push({ name: "SupplierCreate" })
        },
        handleNewAccount() {   
            this.$router.push({ name: "SupplierAccountCreate",  query: { supplier : this.supplier.id } })
        },
        handleEdit() {
            this.$router.push({ name: "SupplierEdit", params: { id: this.id } })
        },
        handleList() {
            this.$router.push({ name: "SupplierList" })
        },
        handleNewContact() {
            this.$router.push({ name: "SupplierContactCreate" , query: { supplier : this.supplier.id } })
        },
        handleRemove() {
            this.alert = {...this.alert, content: "are you sure you want to remove this supplier?", callback: this.removeSupplier};
            this.alertShown = true;
        },
        removeSupplier() {
            this.loading = true;
            this.remove(this.supplier).then(() => {
                this.snackbar({color: "success", text: "Supplier Removed Successfully."});
                this.$router.push({ name: "SupplierSearch" });
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({color: "error", text: message})
            }).finally(() => {
                this.loading = false;
            });
        },
        handleNewPurchaseOrder() {
            this.$router.push({ name: "PurchaseOrderCreate", query: { supplier_id : this.supplier.id}})
        }
    },
    created() {
        this.id = this.$route.params.id;
        this.getSupplier();
    },
    beforeRouteUpdate(to, from, next) {
        this.id = to.params.id;
        this.getSupplier();
        next();
    }
}
</script>

<style>

</style>